import { render, staticRenderFns } from "./_megaH5.vue?vue&type=template&id=675804cd&lang=pug&"
import script from "./_megaH5.vue?vue&type=script&lang=js&"
export * from "./_megaH5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports